export type Ownership = 'own' | 'organisation' | 'network' | 'purchased'

export type LeadType = 'buyer'
